import { useTranslation } from 'react-i18next'

import { MatchingLabelsApi } from '@/services/targeting/targetingLookupApi'
import { StringPicker } from '../StringPicker'

export interface MatchingLabelTargetEditorProps {
  /** The labels targeted — an ad unit carrying any one of them matches. */
  value: string[]
  onChange: (value: string[]) => void
}

/**
 * Picks the ad unit matching labels a line item targets from the labels the
 * network's ad units actually carry, so a label is chosen rather than typed
 * and a typo cannot silently target nothing.
 */
export function MatchingLabelTargetEditor({ value, onChange }: MatchingLabelTargetEditorProps) {
  const { t } = useTranslation()
  const what = t('targeting.types.adUnitMatchingLabel.plural').toLowerCase()

  return (
    <StringPicker
      queryKey="targeting-adUnitMatchingLabel"
      search={(term) => MatchingLabelsApi.search(term)}
      selected={value}
      onChange={onChange}
      addLabel={t('targeting.addType', { what })}
      searchPlaceholder={t('targeting.searchType', { what })}
      emptyText={t('targeting.noneSelected', { what })}
    />
  )
}
